import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import images from "../../../global-styles/images";
const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const FeedbackMetricTileCount = (props: any) => {
  const { title, time, feedbacks, ReportsTicketsTotalCountsData } = props;
  return (
    <>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            margin: "auto",
            maxWidth: 500,
            flexGrow: 1,
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#1A2027" : "#fff",
            boxShadow: "none",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm container>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item sx={{ mt: 5 }}>
                  <Typography
                    sx={{
                      color: "#727272",
                      fontSize: "12px",
                    }}
                    variant="body2"
                  >
                    {/* Active Users */}
                    Total Tickets
                  </Typography>
                  <Typography variant="body2">
                    <span style={{ fontSize: "30px", fontWeight: 600 }}>
                      {ReportsTicketsTotalCountsData == "" ||
                      ReportsTicketsTotalCountsData?.topicCounts?.length == 0
                        ? 0
                        : Number(
                            ReportsTicketsTotalCountsData?.topicCounts
                              ?.overallOpenCount
                          ) +
                          Number(
                            ReportsTicketsTotalCountsData?.topicCounts
                              ?.overallClosedCount
                          ) +
                          Number(
                            ReportsTicketsTotalCountsData?.topicCounts
                              ?.overallPendingResponseCount
                          ) +
                          Number(
                            ReportsTicketsTotalCountsData?.topicCounts
                              ?.overallRepliedCount
                          )}
                    </span>
                    {/* <span style={{ fontSize: "30px", fontWeight: 600 }}>
                      {ReportsTicketsTotalCountsData?.topicCounts
                        ?.overallOpenUserCount || 0}
                    </span> */}
                    {/* <span
                      style={{
                        fontSize: "20px",
                        color: "#6a6868b3",
                        fontWeight: 400,
                      }}
                    >
                      /
                      {ReportsTicketsTotalCountsData?.topicCounts
                        ?.overallUserCount || 0}
                    </span> */}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" component="div">
                  <img className="fbmetrictilesvg" src={images.activeusers} />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            margin: "auto",
            maxWidth: 500,
            flexGrow: 1,
            boxShadow: "none",
            border: "1px solid #ccc",
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#1A2027" : "#fff",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm container>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item sx={{ mt: 5 }}>
                  <Typography
                    sx={{
                      color: "#727272",
                      fontSize: "12px",
                    }}
                    variant="body2"
                  >
                    Replied Tickets
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "30px",
                    }}
                    variant="body2"
                  >
                    {ReportsTicketsTotalCountsData?.topicCounts
                      ?.overallRepliedCount || 0}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" component="div">
                  <img className="fbmetrictilesvg" src={images.questanswers} />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            margin: "auto",
            maxWidth: 500,
            flexGrow: 1,
            boxShadow: "none",
            border: "1px solid #ccc",
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#1A2027" : "#fff",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm container>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item sx={{ mt: 5 }}>
                  <Typography
                    sx={{
                      color: "#727272",
                      fontSize: "12px",
                    }}
                    variant="body2"
                  >
                    Open Tickets
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "30px",
                    }}
                    variant="body2"
                  >
                    {ReportsTicketsTotalCountsData?.topicCounts
                      ?.overallOpenCount || 0}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" component="div">
                  <img className="fbmetrictilesvg" src={images.opentickets} />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default FeedbackMetricTileCount;
